export const URL_BASE = "https://ruteob.sanpabloalimentos.cl"
// export const URL_BASE="http://186.103.221.179:4110"

//IP_BASE=190.54.25.90
